/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLabelText: {
  name: 'label-text';
  data: string;
} = {
  name: 'label-text',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M.646.646a.5.5 0 0 1 .416-.142l8 1a.5.5 0 0 1 .292.142l6 6.002a.5.5 0 0 1 0 .707l-7 7a.5.5 0 0 1-.708 0l-6-6.001a.5.5 0 0 1-.142-.292l-1-8A.5.5 0 0 1 .646.646Zm.93.93.899 7.192L8 14.294 14.293 8 8.768 2.475l-7.192-.9Zm5.07 3.07a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708Zm-1.292 2a.5.5 0 1 0-.708.708l2 2a.5.5 0 1 0 .708-.708l-2-2Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
